import { Link } from 'react-router-dom';

import styled, { css } from 'styled-components';

import colors from '../../../../../theme/colors';
import media from '../../../../../theme/media';

const getBoxShadow = (props) => {
    const raised = props.raised && props.raised.toString() === 'true';
    if (raised) {
        return props.useThemeColor ? props.theme.shadow_grey : `0 0 1px ${colors.codGray12}, 0 0 8px ${colors.codGray04}, 0 8px 8px ${colors.codGray04}`;
    }
    return 'none';
};

const getBackgroundColor = (props) => {
    if (props.variant === 'secondary_filled') {
        return props.useThemeColor ? props.theme.purple_8_tr : colors.purpleRgba08;
    } else if (props.variant === 'primary') {
        return props.useThemeColor ? props.theme.purple_100 : colors.purple;
    }
    return props.useThemeColor ? props.theme.white : colors.white;
};

const getHoveredBackgroundColor = (props) => {
    if (props.variant === 'secondary_filled') {
        return props.useThemeColor ? props.theme.purple_16_tr : colors.purpleRgba16;
    } else if (props.variant === 'primary') {
        return props.useThemeColor ? props.theme.purple_72_lc : colors.purple_72_lc;
    }
    return props.useThemeColor ? props.theme.grey_8_lc : colors.superLightGray;
};

const getFocusedBackgroundColor = (props) => {
    if (props.variant === 'secondary_filled') {
        return props.useThemeColor ? props.theme.purple_8_lc : colors.purpleRgba16;
    } else if (props.variant === 'primary') {
        return props.useThemeColor ? props.theme.purple_100 : colors.purple;
    }
    return props.useThemeColor ? props.theme.white : colors.white;
};

const CommonCss = css`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => getBackgroundColor(props)};
    border: none;
    border-radius: 50%;
    width: ${(props) => (props.size === 'small' ? '28px' : '40px')};
    height: ${(props) => (props.size === 'small' ? '28px' : '40px')};
    padding: 0;
    box-shadow: ${(props) => getBoxShadow(props)};
    pointer-events: auto;
    cursor: pointer;
    margin-right: ${(props) => (props.$marginRight ? props.$marginRight : null)};

    &:hover {
        background-color: ${(props) => getHoveredBackgroundColor(props)};
    }

    &:focus {
        background-color: ${(props) => getFocusedBackgroundColor(props)};
    }

    &:focus-visible {
        outline: 1px dashed ${colors.superLightPurple};
    }

    ${media.desktop1920} {
        width: ${(props) => (props.size === 'small' ? '32px' : '56px')};
        height: ${(props) => (props.size === 'small' ? '32px' : '56px')};
    }
`;

export const CommonButton = styled.button`
    ${CommonCss};
`;
export const LinkButton = styled.a`
    ${CommonCss};
`;
export const ReactLinkButton = styled(Link)`
    ${CommonCss};
`;
